(function() {
    'use strict';
    angular
        .module('emarket.main.profile')
        .controller('ProfileController', ['$scope', '$timeout', '$log', '$rootScope', '$mdMedia', 'Announcer', '$location', '$state', '$mdDialog', '$mdToast', 'Profile', 'Auth', function($scope,
            $timeout,
            $log,
            $rootScope,
            $mdMedia,
            Announcer,
            $location,
            $state,
            $mdDialog,
            $mdToast,
            Profile,
            Auth) {
            var vm = this;
            var announcer = Announcer.create($scope);
            var isMobile = $mdMedia('xs') || $mdMedia('sm');
            vm.user = Auth.getUser();
            vm.hideNavBar = false;

            var showBackButton = function() {
                if ($state.current.name !== 'main.profile.menu' && isMobile) {
                    announcer.emit(Announcer.types.SHOW_BACK_BUTTON);
                    $log.info('sending show back button');
                }
            };

            if (isMobile) {
                $timeout(function() {
                    announcer.emit(Announcer.types.HIDE_SEARCH_BAR);
                    showBackButton();
                });
            }

            showBackButton();

            announcer.on(Profile.events.HIDE_NAV_BAR, function(ev, show) {
                vm.hideNavBar = true;
                if (show) {
                    vm.hideNavBar = false;
                }
            });
            announcer.on(Profile.events.HIDE_STAT_CARD, function(ev, show) {
                vm.hideStatCard = true;
                if (show) {
                    vm.hideStatCard = false;
                }
            });
            Profile.getStat().then(function(stat) {
                vm.stat = stat;
            
            });
            vm.showAddBalanceDialog = function showAddBalanceDialog() {
                Profile.showAddBalanceDialog(vm.user);
            };
            vm.currentNavItem = $state.current.name.match(/(\w+)(\.\w+)(\.\w+)(\.\w+)?/)[0];
            vm.uploadProfilePicture = function(picture) {
                announcer.emit(Profile.events.PROFILE_PICTURE_UPLOAD, picture);
            };
            var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function(event, toState) {
                var found = toState.name.match(/(\w+)(\.\w+)(\.\w+)(\.\w+)?/);
                if (found) {
                    vm.currentNavItem = found[0];
                }
                vm.hideNavBar = false;
                vm.hideStatCard = false;
                if (isMobile && /profile/.test(toState.name)) {
                    $timeout(function() {
                        announcer.emit(Announcer.types.HIDE_SEARCH_BAR);
                        showBackButton();
                    }, 10);
                }
            });

            if ($location.search().editar) {
                vm.edit();
            }
            $scope.$on('$destroy', function() {
                stateChangeSuccessEvent();
                // hideNavbarEvent();
            });
        }]);
}());
